import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Card, Grid, Icon, Loader} from 'semantic-ui-react';
import {
  ResponsiveContainer,
  ComposedChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Line,
  Bar,
  Tooltip,
} from 'recharts';
import {Actions} from '../../../common/actions';
import {colors} from '../../../common/styles/site';
import {getNumericValue} from '../../../common/util/fieldsValidation';

const getChartData = (spentValues, projectedValues) => {
  return moment.months().map((month, index) => {
    return {
      'code': index + 1,
      'name': month,
      'spent': spentValues[index] || 0,
      'projected': projectedValues[index] || 0,
    };
  });
};

class ConsumptionChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'data': getChartData(props.spentValues, props.projectedValues),
    };
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.renderTooltip = this.renderTooltip.bind(this);
    this.handleBarClick = this.handleBarClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {year, updating, activeChart} = this.props;

    if (activeChart && year && prevProps.updating && !updating) {
      this.props.getProviderOrderLimit({'year': year});
    }
  }

  handleCloseClick() {
    this.props.clearProviderOrdersLimitsSelectedYear();
  }

  handleBarClick({payload}) {
    const {year} = this.props;

    if (window.location) {
      const path = `/proveedores/reporte-montos?year=${year}&month=${payload.code}`;
      window.open(`${window.location.origin}${path}`, '_blank');
    }
  }

  getMonthAmount(history, monthPayload) {
    if (monthPayload.code > 1) {
      const value = monthPayload.spent - history[monthPayload.code - 2].spent;
      return value > 0 ? value : 0;
    }

    return monthPayload.spent;
  }

  renderChart() {
    const {loading, spentValues, projectedValues} = this.props;
    const data = getChartData(spentValues, projectedValues);

    if (loading) {
      return (
        <Loader active inline='centered'>
          Consultando...
        </Loader>
      );
    }

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Card raised fluid>
              <ResponsiveContainer width='100%' aspect={8.0 / 2.0}>
                <ComposedChart
                  data={data}
                  margin={{'top': 25, 'left': 30, 'right': 10}}
                >
                  <CartesianGrid />
                  <Tooltip content={this.renderTooltip} />
                  <YAxis
                    label={{
                      'value': 'USD ($)',
                      'angle': -90,
                      'position': 'left',
                      'offset': 17,
                    }}
                  />
                  <XAxis dataKey='name' />
                  <Line
                    dataKey='projected'
                    dot={false}
                    strokeWidth={3}
                    stroke={colors.cadmiumRed}
                  />
                  <Bar
                    dataKey='spent'
                    barSize={20}
                    label={this.renderLegend}
                    fill={colors.unitedNationsBlue}
                    onClick={this.handleBarClick}
                  />
                </ComposedChart>
              </ResponsiveContainer>
            </Card>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  renderLegend({x, y, value}) {
    return (
      <text fill='#000' x={x} dx={5} y={y} dy={-4} textAnchor='middle'>
        $ {getNumericValue(value, 2)}
      </text>
    );
  }

  renderTooltip({active, payload}) {
    if (!active) {
      return null;
    }

    const {spentValues, projectedValues} = this.props;
    const monthPayload = payload[0].payload;
    const history = getChartData(spentValues, projectedValues);

    return (
      <div className='chart-history-tooltip'>
        <div>
          <span className='label'>Consumo acumulado: </span>
          $ {getNumericValue(monthPayload.spent, 2)}
        </div>
        <div>
          <span className='label'>Consumo del mes: </span>
          $ {getNumericValue(this.getMonthAmount(history, monthPayload), 2)}
        </div>
      </div>
    );
  }

  render() {
    const {activeChart, year} = this.props;

    if (!activeChart) {
      return null;
    }

    return (
      <Card raised fluid className='orders-consumption-detail'>
        <Grid>
          <Grid.Row>
            <Grid.Column textAlign='left' width='15'>
              <h2>{year}</h2>
            </Grid.Column>
            <Grid.Column textAlign='right'>
              <Icon
                link
                className='close'
                size='big'
                color='red'
                onClick={this.handleCloseClick}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {this.renderChart()}
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.providerOrdersControl.loading,
    'updating': state.providerOrdersControl.loadingHistory,
    'projectedValues': state.providerOrdersControl.yearLimits,
    'spentValues': state.providerOrdersControl.yearValues,
    'activeChart': state.providerOrdersControl.activeChart,
    'year': state.providerOrdersControl.selectedYear,
  };
};

const {
  navigateTo,
  getProviderOrderLimit,
  clearProviderOrdersLimitsSelectedYear,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  getProviderOrderLimit,
  clearProviderOrdersLimitsSelectedYear,
})(ConsumptionChart);
